import { createReducer, on } from '@ngrx/store';

import { createOrUpdateController, createOrUpdateTab, resetTabControllerState } from './option-group-tab-controller-index-keeper.action';
import { defaultTabControllerState } from './option-group-tab-controller-index-keeper.state';

export const tabControllerReducer = createReducer(
    defaultTabControllerState,
    on(createOrUpdateTab, (state, payload) => {
        const { eventId, marketGroupId, tabIndex } = payload;
        const existingEvent = state[eventId] || {};
        const existingMarketGroup = existingEvent[marketGroupId] || {};
        const existingTab = existingMarketGroup[tabIndex];
        return {
            ...state,
            [eventId]: {
                ...existingEvent,
                [marketGroupId]: {
                    ...existingMarketGroup,
                    lastSelectedTabIndex: tabIndex,
                    [tabIndex]: {
                        controllerId: existingTab ? existingTab.controllerId : 0,
                    },
                },
            },
        };
    }),
    on(createOrUpdateController, (state, payload) => {
        const { eventId, marketGroupId, controllerId } = payload;
        const existingEvent = state[eventId] || {};
        const existingMarketGroup = existingEvent[marketGroupId] || {};
        const selectedTabIndex = existingMarketGroup.lastSelectedTabIndex ?? 0;
        return {
            ...state,
            [eventId]: {
                ...existingEvent,
                [marketGroupId]: {
                    ...existingMarketGroup,
                    lastSelectedTabIndex: selectedTabIndex,
                    [selectedTabIndex]: {
                        controllerId: controllerId,
                    },
                },
            },
        };
    }),
    on(resetTabControllerState, () => defaultTabControllerState),
);
